"use strict";
var common_1 = require("@angular/common");
var base_1 = require("@bhtp-client-api/base");
var type_ahead_1 = require("./../../type-ahead");
var rental_information_view_model_1 = require("./rental-information-view.model");
var CoverageViewModel = (function () {
    function CoverageViewModel() {
    }
    CoverageViewModel.createCoverages = function (coverages, toConvertTypes, forPurchase, currentOptionalCoverages) {
        if (currentOptionalCoverages === void 0) { currentOptionalCoverages = null; }
        var viewCoverages = new Array();
        //  Build coverage view models
        if (coverages && coverages.length > 0 && toConvertTypes != null && toConvertTypes.length > 0) {
            for (var i = 0; i <= coverages.length - 1; i++) {
                if (coverages[i] && coverages[i].type && toConvertTypes.indexOf(coverages[i].type.toLowerCase()) >= 0) {
                    var coverage = new CoverageViewModel();
                    coverage.name = coverages[i].name;
                    coverage.shortName = coverages[i].shortName;
                    coverage.coverageLimitDisplayText = coverages[i].coverageLimitDisplayText;
                    coverage.isSelected = coverages[i].isSelected;
                    coverage.ratingId = coverages[i].ratingId;
                    coverage.coverageLimit = coverages[i].coverageLimit;
                    coverage.limits = coverages[i].limits;
                    coverage.premiumsByLimit = coverages[i].premiumsByLimit;
                    coverage.canRemoveCoverage = coverages[i].canRemoveCoverage;
                    coverage.premium = coverages[i].premium;
                    coverage.premiumsByDay = coverages[i].premiumsByDay;
                    coverage.fees = coverages[i].fees;
                    coverage.description = coverages[i].description;
                    coverage.forPurchase = forPurchase;
                    coverage.acknowledgements = coverages[i].acknowledgements;
                    coverage.type = coverages[i].type;
                    coverage.requires = coverages[i].requires;
                    viewCoverages.push(coverage);
                }
            }
        }
        // Reconcile coverages move selected options over
        if (currentOptionalCoverages) {
            for (var i = 0; i <= viewCoverages.length - 1; i++) {
                // Reset can remove flag,  it will be set by the coverages we got from edit,  in the case that there are no optional coverages we will reset
                // edit flag on them all.
                viewCoverages[i].canRemoveCoverage = true;
                for (var i2 = 0; i2 <= currentOptionalCoverages.length - 1; i2++) {
                    if (viewCoverages[i].ratingId.toLowerCase() === currentOptionalCoverages[i2].ratingId.toLocaleLowerCase()) {
                        viewCoverages[i].isSelected = currentOptionalCoverages[i2].isSelected;
                        viewCoverages[i].coverageLimit = currentOptionalCoverages[i2].coverageLimit;
                        // If the coverage has mutipal limits we need to calculate the correct display text.
                        if (arrayDefinedAndMultipleValues(viewCoverages[i].limits) && arrayDefinedAndMultipleValues(viewCoverages[i].premiumsByLimit)) {
                            // Update Display Text for optional coverages with limits
                            viewCoverages[i].coverageLimitDisplayText = CoverageViewModel.getCoverageLimitDisplayText(currentOptionalCoverages[i2]);
                            // Set premium for coverages with limits
                            viewCoverages[i].premium = CoverageViewModel.setCoveragePremium(viewCoverages[i]);
                        }
                        else if (currentOptionalCoverages[i2].daySpan && viewCoverages[i].premiumsByDay) {
                            viewCoverages[i].premium = viewCoverages[i].premiumsByDay[currentOptionalCoverages[i2].daySpan];
                        }
                        viewCoverages[i].canRemoveCoverage = currentOptionalCoverages[i2].canRemoveCoverage;
                        break;
                    }
                }
            }
        }
        // Return coverages
        return viewCoverages;
        function arrayDefinedAndMultipleValues(array) {
            return Boolean(array.length && array.length > 1);
        }
    };
    CoverageViewModel.combineOptionalCoverageFormGroupAndEditCoverageToEditCoverage = function (coverageModel, formGroup) {
        coverageModel.isSelected = formGroup.controls['selected'].value;
        if (formGroup.controls['limitSelection']) {
            coverageModel.coverageLimit = Number(formGroup.controls['limitSelection'].value);
        }
        return coverageModel;
    };
    CoverageViewModel.combineOptionalCoverageFormGroupAndCoverageToRentalInformation = function (coverageModel, formGroup) {
        var convertedRentalInformation = new rental_information_view_model_1.RentalInformationViewModel();
        if (formGroup.controls['carRentalCompany'] && formGroup.controls['carRentalCompany'].value) {
            convertedRentalInformation.carRentalCompany = type_ahead_1.TypeaheadHelper.extractTypeaheadValue(formGroup.controls['carRentalCompany'].value);
        }
        if (formGroup.controls['pickupDate']) {
            convertedRentalInformation.rentalCarPickupDate = formGroup.controls['pickupDate'].value;
        }
        if (formGroup.controls['dropoffDate']) {
            convertedRentalInformation.rentalCarReturnDate = formGroup.controls['dropoffDate'].value;
        }
        return convertedRentalInformation;
    };
    CoverageViewModel.hasDates = function (coverage) {
        return coverage.ratingId === 'CRCC';
    };
    CoverageViewModel.canAddLimitControl = function (coverage) {
        return coverage.limits && coverage.limits.length > 1 && (coverage.canRemoveCoverage || coverage.forPurchase);
    };
    CoverageViewModel.fromApiCoverageDetail = function (source) {
        var target = new CoverageViewModel();
        target.acknowledgements = source.acknowledgements;
        target.canRemoveCoverage = source.canRemoveCoverage;
        target.coverageLimit = source.coverageLimit;
        target.coverageLimitDisplayText = source.coverageLimitDisplayText;
        target.daySpan = source.daySpan;
        target.description = source.description;
        target.fees = source.fees;
        target.isSelected = source.isSelected;
        target.limits = source.limits;
        target.name = source.name;
        target.premium = source.premium;
        target.premiumsByDay = source.premiumsByDay;
        target.premiumsByLimit = source.premiumsByLimit;
        target.ratingId = source.ratingId;
        target.shortName = source.shortName;
        target.type = source.type;
        target.requires = source.requires;
        return target;
    };
    CoverageViewModel.toApiEditCoverages = function (coverages) {
        var apiCoverages = new Array();
        if (coverages) {
            for (var i = 0; i <= coverages.length - 1; i++) {
                apiCoverages.push(this.toApiEditCoverage(coverages[i]));
            }
        }
        return apiCoverages;
    };
    CoverageViewModel.toApiEditCoverage = function (coverage) {
        var apiCoverages = new base_1.ApiCoverageDetail();
        apiCoverages.ratingId = coverage.ratingId;
        apiCoverages.acknowledgements = coverage.acknowledgements;
        apiCoverages.canRemoveCoverage = coverage.canRemoveCoverage;
        apiCoverages.coverageLimit = coverage.coverageLimit;
        apiCoverages.coverageLimitDisplayText = coverage.coverageLimitDisplayText;
        apiCoverages.daySpan = coverage.daySpan;
        apiCoverages.description = coverage.description;
        apiCoverages.fees = coverage.fees;
        apiCoverages.isSelected = coverage.isSelected;
        apiCoverages.limits = coverage.limits;
        apiCoverages.name = coverage.name;
        apiCoverages.premium = coverage.premium;
        apiCoverages.premiumsByDay = coverage.premiumsByDay;
        apiCoverages.premiumsByLimit = coverage.premiumsByLimit;
        apiCoverages.shortName = coverage.shortName;
        apiCoverages.type = coverage.type;
        return apiCoverages;
    };
    CoverageViewModel.getCoverageLimitDisplayText = function (coverage) {
        var converter = new common_1.CurrencyPipe('US');
        return converter.transform(coverage.coverageLimit, 'USD', true, '1.0-0');
    };
    CoverageViewModel.setCoveragePremium = function (coverage) {
        var premium = null;
        premium = coverage.premiumsByLimit[coverage.coverageLimit];
        return premium;
    };
    return CoverageViewModel;
}());
exports.CoverageViewModel = CoverageViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/coverages/coverage-view.model.js